import { useTranslations } from "next-intl";
import CheckIcon from "../_icons/checkIcon";
import { cloverColorTheme } from "@/utils/cloverColorTheme";
import { useEffect, useState } from "react";
import { useHeaderHeight } from "@/app/providers/navigationProvider";
import { usePathname } from "next/navigation";
import { useMerchant } from "@/app/providers/merchantProvider";

const SECONDARY_NAVIGATION_HEIGHT = 72;
const SECONDARY_NAVIGATION_ROUTES = ["/services", "/menu", "/shop"];
export interface CustomerLoggedInBannerProps {
  customerName?: string;
  visible?: boolean;
  isMobileScreen?: boolean;
}

export const CustomerLoggedInBanner = ({
  customerName,
  visible = true,
  isMobileScreen = false,
}: CustomerLoggedInBannerProps) => {
  const t = useTranslations("CustomerLoggedInBanner");
  const pathName = usePathname();
  const { merchant } = useMerchant();
  const [displayMessage, setDisplayMessage] = useState("");
  const { headerContentRef } = useHeaderHeight();
  const height = headerContentRef.current?.clientHeight ?? 0;
  const isHybridShop = pathName?.includes("/shop") && merchant.isHybrid;
  const hasSecondaryNav =
    SECONDARY_NAVIGATION_ROUTES.some((route) => pathName?.includes(route)) ||
    isHybridShop;
  const enterAnimation = isMobileScreen
    ? "toast-enter-bottom"
    : "toast-enter-top";
  const leaveAnimation = isMobileScreen
    ? "toast-leave-bottom"
    : "toast-leave-top";

  useEffect(() => {
    if (!customerName) {
      setDisplayMessage(t("helloThere"));
      return;
    }

    const messages = [
      t("welcomeBack", { customerName }),
      t("seeYouAgain", { customerName }),
    ];

    setDisplayMessage(getRandomItem(messages));
  }, [customerName]);

  return (
    <div
      role="alert"
      aria-live="assertive"
      style={{
        marginTop: `${
          height - (hasSecondaryNav ? SECONDARY_NAVIGATION_HEIGHT : 10)
        }px`,
        marginBottom: isMobileScreen ? "20px" : "0px",
        animation: visible
          ? `${enterAnimation} 0.5s`
          : `${leaveAnimation} 0.5s`,
      }}
      className={`
          bg-[#F2FCEE] rounded-lg border border-[#228800] flex gap-3 p-3 items-center ${
            !isMobileScreen ? "mr-6" : ""
          }
          ${visible ? "opacity-100" : "opacity-0"}
        `}
    >
      <CheckIcon color={cloverColorTheme.Main.primaryColor} />
      <span className="text-base">{displayMessage}</span>
    </div>
  );
};

export const getRandomItem = <T,>(arr: T[]): T => {
  const randomIndex = Math.floor(Math.random() * arr.length); // NOSONAR
  return arr[randomIndex];
};
